export default class BudgetTableData {

    constructor(monthNumbers, rows, cashFlowValuesList) {
        this.monthNumbers = monthNumbers;
        this.rows = rows;
        this.cashFlowValuesList = cashFlowValuesList;
    }
}